import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/explore/components/ExploreRootSidebar/ExploreRootSidebar.tsx");
